<div class='list-container'>
  <div class='d-flex justify-content-between' *ngIf='headerNeeded'>
    <h2 class='card-title'
        *ngIf='selectedItem && testLoaded'>{{selectedItem.calculationResult.testType | titlecase}} Test Details</h2>
    <h2 class='card-title'
        [hidden]='selectedItem && testLoaded'>Loading Test Details...</h2>
    <div class='button-group' *ngIf='selectedItem && testLoaded'>
      <button data-toggle='modal' data-target='#geotagModal'
              class='btn test-detail-button d-inline-flex align-items-center mr-2 mb-1 mb-lg-0'>
        Custom Geotag
      </button>
      <button data-toggle='modal' data-target='#emailModal'
              class='btn test-detail-button d-inline-flex align-items-center mr-2 mb-1 mb-lg-0'>
        <img src='../../../assets/EmailVector.png' height='12'
             class='mr-2'
             width='14'/>Email
      </button>
      <button class='btn test-detail-button d-inline-flex mr-2 align-items-center'
              (click)='createPdf()'>
        <img
          class='mr-2'
          src='../../../assets/DLVector.png' height='12' width='10'/>Download
      </button>
      <button class='btn test-detail-button d-inline-flex align-items-center' data-toggle='modal'
              data-target='#deleteTestModal'>
        Delete Test
      </button>
    </div>
  </div>
  <div class='row' *ngIf='locationHeaderNeeded' (click)='navigateToTest(selectedItem.calculationResult.testId)'
       [ngClass]='{"pointer-cursor":locationHeaderNeeded}'>
    <div class='d-flex justify-content-between col-12'>
      <div class='text-primary font-weight-bold'>
        {{userDisplayName || userEmail}}
      </div>
    </div>
  </div>
  <hr *ngIf='locationHeaderNeeded'>
  <div class='row'>
    <div class='col-12 col-lg-6 pb-2'>
      <small class='d-block'>DATE & TIME</small>
      <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }" [hidden]='selectedItem && testLoaded'></ngx-skeleton-loader>
      <p *ngIf='selectedItem && testLoaded'
         class='card-text'>{{(selectedItem.calculationResult.date.seconds * 1000 | date :'short') || selectedItem.calculationResult.date._seconds * 1000 | date :'short'}}</p>

    </div>
    <div class='col-12 col-lg-6 pb-2'>
      <small class='d-block'>TEST ID</small>
      <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }" [hidden]='selectedItem && testLoaded'></ngx-skeleton-loader>
      <p *ngIf='selectedItem && testLoaded'
         class='card-text'>{{selectedItem.calculationResult.testId}}</p>
    </div>
  </div>
  <div class='row'>
    <div class='col-12 col-lg-6 dropdown-container pb-2'>
      <small class='d-block'>LOCATION</small>
      <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }" [hidden]='selectedItem && testLoaded'></ngx-skeleton-loader>
      <div class='card-text'
           [ngClass]='{"pointer-cursor": locationEditNeeded}'
           *ngIf='selectedItem?.location && !isEditingLocation && testLoaded'
           (click)='locationEditNeeded ? isEditingLocation = true : null'>
        {{selectedItem.location.name ? selectedItem.location.name : "No Location Chosen"}}

      </div>
      <div class='card-text'
           [ngClass]='{"pointer-cursor": locationEditNeeded}'
           *ngIf='!selectedItem?.location && !isEditingLocation && testLoaded'
           (click)='locationEditNeeded ? isEditingLocation = true : null'>
        No Location Chosen

      </div>
      <app-location-dropdown [apiUid]='selectedItem.uid.toString()' [idToken]='idToken'
                             [userSavedPlaces]='userSavedPlaces'
                             [selectedItem]='selectedItem'
                             *ngIf='isEditingLocation && userSavedPlaces'
                             [labelNeeded]='false'
                             [focusNeeded]='true'
                             [widthNeeded]='true'
                             [clearNeeded]='false'
                             (getUserData)='getUserSavedData($event)'></app-location-dropdown>
      <!--                      <p-->
      <!--                        class='card-text'>{{selectedItem.location.formatted_address ? selectedItem.location.formatted_address : selectedItem.location.name ? selectedItem.location.name : selectedItem.location}}</p>-->
    </div>
    <div class='col-12 col-lg-6 dropdown-container pb-2'>
      <small class='d-block'>WATER SOURCE</small>
      <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }" [hidden]='selectedItem && testLoaded'></ngx-skeleton-loader>
      <div *ngIf='(selectedItem?.location || selectedItem?.waterSource) && !isEditingWaterSource && testLoaded'
           (click)='this.isEditingWaterSource = true'
           class='text-capitalize pointer-cursor card-text'>

        {{selectedItem.location?.waterSource !== undefined ? selectedItem.location?.waterSource ? selectedItem.location?.waterSource : "No Water Source Chosen" : selectedItem.waterSource}}
      </div>
      <div *ngIf='!selectedItem?.location && !selectedItem?.waterSource && !isEditingWaterSource && testLoaded'
           (click)='this.isEditingWaterSource = true'
           class='text-capitalize pointer-cursor card-text'>

        No Water Source Chosen
      </div>
      <app-water-source-dropdown [apiUid]='selectedItem.uid.toString()' [idToken]='idToken'
                                 [userSavedWaterSources]='userSavedWaterSources'
                                 [selectedItem]='selectedItem'
                                 [labelNeeded]='false'
                                 [focusNeeded]='true'
                                 [widthNeeded]='true'
                                 [clearNeeded]='false'
                                 *ngIf='isEditingWaterSource && userSavedWaterSources'
                                 (getUserData)='getUserSavedData()'></app-water-source-dropdown>

    </div>
  </div>
  <div class='row'>
    <div class='col-12 col-lg-6 pb-2'>
      <small class='d-block'>DEVICE ID</small>
      <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }" [hidden]='selectedItem && testLoaded'></ngx-skeleton-loader>
      <p class='card-text'
         *ngIf='selectedItem && testLoaded'> {{selectedItem.calculationResult.deviceMacAddress}}</p>
    </div>
    <div class='col-12 col-xl-6 pb-2'>
      <small class='d-block'>RESULTS</small>
      <ngx-skeleton-loader count='1' [theme]="{
          'width': '75%'
        }" [hidden]='selectedItem && testLoaded'></ngx-skeleton-loader>
      <p class='card-text d-flex justify-content-between'
         *ngIf='selectedItem && testLoaded'>{{selectedItem.calculationResult.textDescription}}<span
        *ngIf='selectedItem && testLoaded'>
        <img
          *ngIf='selectedItem.calculationResult.testType === "bacteria" && selectedItem.calculationResult.bacteriaLevel >= 5000'
          alt='high' src='../../../assets/testicons/high.png' height='24' width='46'/>
        <img
          *ngIf='selectedItem.calculationResult.testType === "bacteria" && selectedItem.calculationResult.bacteriaLevel >= 500 && selectedItem.calculationResult.bacteriaLevel < 5000'
          alt='medium' src='../../../assets/testicons/medium.png' height='24' width='46'/>
        <img
          *ngIf='selectedItem.calculationResult.testType === "bacteria" && selectedItem.calculationResult.bacteriaLevel < 500'
          alt='low' src='../../../assets/testicons/low.png' height='24' width='46'/>
      </span></p>

    </div>
  </div>
  <div class='row'>
    <div class='col-12'>
      <small class='d-block'>NOTES</small>
      <ngx-skeleton-loader count='1' [theme]="{
          'width': '100%'
        }" [hidden]='selectedItem && testLoaded'></ngx-skeleton-loader>
      <div *ngIf='selectedItem?.location && !isEditingNote && testLoaded'
           (click)='isEditingNote = true'
           class='text-capitalize pointer-cursor card-text'>
        {{selectedItem.note ? selectedItem.note : '+ Add Note'}}
      </div>
      <mat-form-field *ngIf='isEditingNote' class='w-100'>
        <input matInput tabindex='-1' type='text'
               name='txtNote'
               [value]='selectedItem.note ? selectedItem.note : ""'
               (keyup.enter)='handleNoteChange($event,selectedItem.calculationResult.testId)'
               (blur)='handleNoteChange($event,selectedItem.calculationResult.testId)'>
      </mat-form-field>
    </div>
  </div>

</div>

<!-- Modal -->
<div class='modal fade' *ngIf='headerNeeded' id='emailModal' tabindex='-1' role='dialog' aria-labelledby='modalTitle'
     aria-hidden='true'>
  <app-email-template [email]='email' [selectedItem]='selectedItem' [idToken]='idToken'></app-email-template>
</div>


<!--Delete Test Modal-->

<div class='modal fade' tabindex='-1' role='dialog' id='deleteTestModal' aria-labelledby='deleteTestModalLabel'
     aria-hidden='true'>
  <div class='modal-dialog' role='document'>
    <div class='modal-content'>
      <div class='modal-header'>
        <h3 class='modal-title'>Deleting Test</h3>
        <button type='button' class='close' data-dismiss='modal' aria-label='Close'>
          <span aria-hidden='true'>&times;</span>
        </button>
      </div>
      <div class='modal-body'>
        <p>Are you sure you want to delete this test? This will be permanent.</p>
      </div>
      <div class='modal-footer'>
        <button type='button' class='btn btn-danger' data-dismiss='modal' (click)='deleteTest(selectedItem)'>Delete</button>
        <button type='button' class='btn btn-secondary' data-dismiss='modal'>Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Geotag Modal -->
<div class='modal fade' id='geotagModal' tabindex='-1' role='dialog' aria-labelledby='modalTitle'
     aria-hidden='true'>
  <app-geotag-modal *ngIf='testLoaded && selectedItem' [location]='selectedItem.location' [idToken]='idToken' [uid]='selectedItem.uid' (updateMap)='updateMap($event)'></app-geotag-modal>
</div>
